export default {
    LOAD_BANNERSECTOR (state, bannersectors) {
        state.items = bannersectors
    }
}